import script from "./MoreList.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreList.vue?vue&type=script&setup=true&lang=js"

import "./MoreList.vue?vue&type=style&index=0&id=7c0c6f58&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c0c6f58"]])

export default __exports__